export const DASHBOARD = "DASHBOARD";
export const MANAGE = "MANAGE";



// WEBPACK FOOTER //
// ./src/Navigation/Consts.tsx